import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { delay } from 'q';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import * as d3 from 'd3';

@Component({
  selector: 'app-play-animation-scalebar',
  templateUrl: './play-animation-scalebar.component.html',
  styleUrls: ['./play-animation-scalebar.component.scss']
})
export class PlayAnimationScalebarComponent implements OnInit {

  @Input() activeSideMenu: any;
  @Output() groupSelected = new EventEmitter<any>();
  // @Input() labelsStrings: any;
  // @Input() blockLength: any;

  previousIndex:number = 0;
  state='stop';
  visitedColumnindex:number=0;
  timeLaggingDuration:string='500';
  parentNextIndex:any=0;
  childNextIndex:any = null;
  activeGroupLabel:any= ''
  labelsStrings:any;
  blockLength: any;

  constructor(
    public utilsSrv: UtilsService,
  ) {
   
   }

   ngOnChanges(changes: SimpleChanges) {
    if(changes['labelsStrings'] && changes['labelsStrings'].currentValue){
      this.ngOnInit()
    }
  }

  ngOnInit() {
    this.utilsSrv.seamlessLabelStrings.subscribe(data => {
      this.labelsStrings = data['labelsStrings'];
      this.blockLength = data['blockLength']
      this.emitFirstValue();
    })
  }

  async emitFirstValue() {
    if (this.labelsStrings.length > 0) {
      await delay(1000);
      this.previousIndex = 0;
      $('#block-' + this.previousIndex).addClass("active");
      this.visitedColumnindex = 0
      this.childNextIndex = this.labelsStrings[0].child.length > 0 ? 0 : null;
      this.parentNextIndex = !isNullOrUndefined(this.childNextIndex) ? 0 : 1;
      this.activeGroupLabel = this.labelsStrings[0].parent.label.label;
      this.groupSelected.emit(this.labelsStrings[0].parent.groupName);
    }

  }

  
  changeButton() {
    if (this.state == 'stop') {
      d3.select('#button_play i').attr('class', 'fa fa-pause-circle');
      this.state='play'
    } else {
      d3.select('#button_play i').attr('class', 'fa fa-play-circle');
      this.state='stop'
    }

  }

  updateProgressBar(updatedBy:string,parentIndex:number,childIndex?:number){
    if(updatedBy == 'parent'){
      this.visitedColumnindex=this.labelsStrings[parentIndex].parent['blockIndex'];
    }
    else if(updatedBy == 'child'){
      this.visitedColumnindex=this.labelsStrings[parentIndex].child[childIndex]['blockIndex'];
    }
    this.updateParentAndChildNextIndices(updatedBy,parentIndex,childIndex)


    $('#block-'+this.previousIndex).removeClass("active")
    $('#block-'+this.visitedColumnindex).addClass("active")

    this.previousIndex = this.visitedColumnindex;
    if(updatedBy == 'parent'){
      this.activeGroupLabel = this.labelsStrings[parentIndex].parent['label'].label
      this.groupSelected.emit(this.labelsStrings[parentIndex].parent['groupName']);

    }
    else if(updatedBy == 'child'){
      this.activeGroupLabel = this.labelsStrings[parentIndex].child[childIndex]['label'].label
      this.groupSelected.emit(this.labelsStrings[parentIndex].child[childIndex]['groupName']);
    }
    this.animate()
  }

  async animate() {
    this.changeButton();
    let parentListLength: any = this.blockLength;
    if (this.visitedColumnindex >= parentListLength-1) {
      this.visitedColumnindex = 0;
      this.parentNextIndex = 0;
      this.childNextIndex = null
      await delay(1500)
    }
    // this.index=this.visitedColumnindex;
    if (this.state == 'play') {
      for (let parentIndex: any = this.parentNextIndex; parentIndex < this.labelsStrings.length; parentIndex++) {
        if (this.childNextIndex == null && this.state == 'play') {
          this.visitedColumnindex = this.labelsStrings[parentIndex].parent['blockIndex'];
          $('#block-' + this.previousIndex).removeClass("active")
          $('#block-' + this.visitedColumnindex).addClass("active")
  
          this.previousIndex = this.visitedColumnindex;
          if (this.visitedColumnindex >= parentListLength-1) {
            this.changeButton();
          }
          this.activeGroupLabel = this.labelsStrings[parentIndex].parent['label']['label']
          this.groupSelected.emit(this.labelsStrings[parentIndex].parent['groupName'])
          this.updateParentAndChildNextIndices('parent',parentIndex)
          await delay(Number(this.timeLaggingDuration));
        }
        if (this.labelsStrings[parentIndex].child.length > 0) {
          let currentChildIndex: any = !isNullOrUndefined(this.childNextIndex) ? this.childNextIndex : 0;
          for (let childIndex: any = currentChildIndex; childIndex < this.labelsStrings[parentIndex].child.length; childIndex++) {
            if (this.state == 'play') {
              this.visitedColumnindex = this.labelsStrings[parentIndex].child[childIndex]['blockIndex'];
  
              $('#block-' + this.previousIndex).removeClass("active")
              $('#block-' + this.visitedColumnindex).addClass("active")
  
              this.previousIndex = this.visitedColumnindex;
  
              if (this.visitedColumnindex >= parentListLength-1) {
                this.changeButton();
              }
              this.activeGroupLabel = this.labelsStrings[parentIndex].child[childIndex]['label']['label'];
              this.groupSelected.emit(this.labelsStrings[parentIndex].child[childIndex]['groupName']);
              this.updateParentAndChildNextIndices('child',parentIndex,childIndex)
              await delay(Number(this.timeLaggingDuration));
            } 
          }
        }
      }
    }
    else{
    }
   

  }

  updateParentAndChildNextIndices(updatedBy:string,currentParent:number,currentChild?:number){
    if(updatedBy == 'parent'){
      this.childNextIndex = this.labelsStrings[currentParent]['child'].length > 0 ? 0 : null;
      this.parentNextIndex = !isNullOrUndefined(this.childNextIndex) ? currentParent : currentParent+ 1 ;
    }
    else if(updatedBy == 'child'){
      this.childNextIndex = this.labelsStrings[currentParent]['child'].length > 0 ? currentChild + 1  < this.labelsStrings[currentParent]['child'].length ? currentChild + 1 : null : null;
      this.parentNextIndex = !isNullOrUndefined(this.childNextIndex) ? currentParent : currentParent+ 1 ;
    }
  }

}
